import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { IRadioGroupProps } from './IRadioGroupProps'
import React from 'react'
import clsx from 'clsx'
import { useRadioGroupValidationSchema } from './RadioGroupValidationSchema'

interface IRadioGroupFieldProps extends HTMLAttributes<HTMLInputElement>, IRadioGroupProps {
}

export const SimpleRadioGroup: FC<IRadioGroupFieldProps> = (props) => {
    const { id, value: initValue, className, title, required, disabled, options } = props
    const schema = useRadioGroupValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <div className="d-flex gap-3">
            {options?.map(({ label, value: optionValue }, i) => <React.Fragment key={i}>
                <div title={title} className="form-check">
                    <label htmlFor={`${id}-${optionValue}`}
                        className={clsx("form-check-label fw-semibold fs-7 my-0", { "required": required })}>
                        {label}
                    </label>
                    <input
                        type="radio"
                        id={`${id}-${optionValue}`}
                        value={optionValue}
                        className={clsx(className, "form-check-input")}
                        checked={optionValue === value}
                        disabled={disabled}
                        onChange={handleChange}
                    />
                </div>
            </React.Fragment>)}
        </div>
        {error && <FieldError show={true} message={error} />}
    </>
}
